import { ViewportScroller } from '@angular/common';
import {
    Component,
    EventEmitter,
    Input,
    Output,
    ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';

@Component({
    selector: 'fe-precheckin-buttons',
    templateUrl: './precheckin-buttons.component.html',
    styleUrls: ['./precheckin-buttons.component.scss'],
})
export class PrecheckinButtonsComponent {
    @Output() submitForm = new EventEmitter<void>();
    @Input() disabled = false;
    @Input() loading = false;

    public confirmButtonText?: string;
    public cancelButtonText?: string;

    @ViewChild('precheckinTemplateButtons')
    private precheckinSwal!: SwalComponent;

    constructor(
        private translate: TranslateService,
        private router: Router,
        private viewportScroller: ViewportScroller,
    ) {}

    onClick() {
        this.submitForm.emit();
    }

    onKeydown(event: any) {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.onClick();
        }
    }

    swal() {
        const confirmButtonText = this.translate.instant(
            'fe_precheckin_layout_swal_confirm',
        );
        const cancelButtonText = this.translate.instant(
            'fe_precheckin_layout_swal_cancel',
        );

        this.precheckinSwal.update({
            confirmButtonText,
            cancelButtonText,
        });

        // FIX: change this logic
        this.precheckinSwal.fire().then((result) => {
            if (result.isConfirmed) {
                this.router.navigate(['/']).then(() => {
                    setTimeout(() => {
                        this.viewportScroller.scrollToPosition([0, 0]);
                    }, 300);
                });
            }
        });
    }
}
